<app-gallery-map
  #galleryMap
  [markers]="markers()"
  [footprints]="footprints()"
  (boundsChange)="onBoundsChange($event)"
  (markerClick)="onItemClick($event.id)"
  (footprintClick)="onItemClick($event.id)"></app-gallery-map>
